// src/hooks/useHydrateModuleFromUrl.ts
import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { ACTIVE_MODULE_KEYS, IMultiplacerModuleKey } from "@multiconsult-group/multiplacer-core";
import { changeActiveModuleThunk } from "../DesignTab/designThunk";

export const useHydrateModuleFromUrl = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const activeModule = useAppSelector((state) => state.design.activeModule);
  const lastHandledModuleRef = useRef<string | null>(null);

  useEffect(() => {
    // Støtter både ?module= og ?mod=
    const moduleParam = searchParams.get("module") ?? searchParams.get("mod");
    if (!moduleParam) return;

    const normalizedModuleParam = moduleParam.toUpperCase();

    if (lastHandledModuleRef.current === normalizedModuleParam) {
      return;
    }

    lastHandledModuleRef.current = normalizedModuleParam;

    const key = normalizedModuleParam as IMultiplacerModuleKey;

    // Sikrer at vi bare aksepterer gyldige moduler
    if (!ACTIVE_MODULE_KEYS.includes(key)) return;

    if (activeModule === key) return;

    dispatch(changeActiveModuleThunk(key));
  }, [activeModule, dispatch, searchParams]);
};
